// removed by extract-text-webpack-plugin
module.exports = {"Player":"_29ceN2Jph_83IAsaDpZxqf","Form":"_3fLV1Ib0rIrFyx7rRzMOTG","Button":"_1hfnD7hKcfCEnKIoc-cd3e","Url":"t0IQrFDCVzQs3ydtxneLf","Error":"_2kbomvKAkbZ0UkybCl_BOL","Controls":"_2vFTU70nHVHTe7QdA2-WcR","Control":"_1AGbv0sUVfFVIr3binDZza","Slidecontainer":"_22JFFQs5alwno7Zc8dGLeC","Slider":"_1ibiCiOOfAEqtFSQpg4bEd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Player/Player.css
// module id = 167
// module chunks = 0